async function sha256(data: BufferSource): Promise<ArrayBuffer> {
  let buffer: ArrayBuffer;
  if (data instanceof ArrayBuffer) {
    buffer = data;
  } else if (ArrayBuffer.isView(data) && data.buffer instanceof ArrayBuffer) {
    buffer = data.buffer.slice(
      data.byteOffset,
      data.byteOffset + data.byteLength,
    ) as ArrayBuffer;
  } else {
    throw new Error('Unsupported data type for digest()');
  }

  const msgUint8 = new Uint8Array(buffer);
  const hashBuffer = await import('js-sha256').then(({ sha256 }) => {
    const hashBytes = sha256.arrayBuffer(msgUint8);
    return hashBytes;
  });
  return hashBuffer;
}

// Ensure that the crypto.subtle.digest is polyfilled for local development
if (!window.crypto?.subtle) {
  console.warn('⚠️ crypto.subtle.digest polyfilled (dev only)');
  (window.crypto as any).subtle = {
    digest: (algorithm: string, data: BufferSource) => {
      if (algorithm !== 'SHA-256') {
        return Promise.reject(new Error('Only SHA-256 is supported'));
      }
      return sha256(data);
    },
  };
}
